<template>
	<div class="ads-preview scroll-content">
		<!-- 附加信息 -->
		<addMessages :adCustomerAssetVo="adCustomerAssetVo" class="scroll-item"></addMessages>
		<!-- 广告系列广告预览 -->
		<structure v-bind="item" v-for="(item, index) in adCampaignVoList" :key="index"></structure>
		<groupNavPanel :groupsForm="groupsForm"></groupNavPanel>
	</div>
</template>

<script>
import structure from './structure';
import addMessages from './add-messages';
import groupNavPanel from './groupNavPanel';
export default {
	props: ['adCustomerAssetVo', 'adCampaignVoList'],
	data() {
		return {};
	},
	components: { addMessages, structure, groupNavPanel },
	computed: {
		groupsForm() {
			let arr = [];
			if (this.adCampaignVoList && this.adCampaignVoList.length) {
				arr = this.treeToArr(this.adCampaignVoList);
				arr.unshift(
					// {
					// 	name: '选择账户结构',
					// 	child: true,
					// },
					{
						name: '账户附加信息',
						child: true,
					}
				);
			}

			return arr;
		},
	},

	methods: {
		treeToArr(data, res = []) {
			data.forEach(item => {
				res.push({
					name: item.campainName || item.adGroupName,
					child: item.adGroupVos && item.adGroupVos.length ? true : false,
				});
				if (item.adGroupVos && item.adGroupVos.length !== 0) {
					let arr1 = [];
			
				let arr =item.adGroupVos.filter(e => {
					return e.parentId;
				});

				arr1 = item.adGroupVos.filter(e => {
					return !e.parentId;
				});
				for (let i = 0; i < arr.length; i++) {
					for (let j = 0; j < arr1.length; j++) {
						if (arr1[j].id == arr[i].parentId) {
							arr1.splice(j + 1, 0, arr[i]);
						}
					}
				}
				item.adGroupVos=arr1;
					this.treeToArr(arr1, res);
				}
			});
			return res;
		},
	},
};
</script>

<style lang="scss" scoped>
.ads-preview {
	/* transform: scale(1, 1); */
	.linediv {
		position: fixed;
		top: 100px;
		right: 50px;
		z-index: 999;
		background-color: #ffffff;
		box-shadow: 0 2px 10px 0 #eaeaea;
		padding: 24px 18px;
		border-radius: 4px;
		.boldFont {
			font-size: 14px;
			font-weight: bold;
			line-height: 30px;
		}
		.smallFont {
			font-size: 12px;
			color: #666666;
			width: 200px;
			margin-left: 25px;
			text-align: left;
			line-height: 30px;
			// min-height: 30px;
		}
	}
}
.scroll-content {
	// height: 500px;

	// overflow: ;
}
</style>
